module.exports = "<template> <h1>${'page_not_found' | t}</h1> </template> ";